// @core/api/endpoints/billing/update_invoice_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InvoiceNumberingSchemeResponse,
  UpdateInvoiceNumberingSchemeRequest,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Update invoice numbering scheme
 * Updates an existing invoice numbering scheme.
 */
export async function UpdateInvoiceNumberingScheme(
  scheme_id: string,
  data: UpdateInvoiceNumberingSchemeRequest,
  options?: RequestOptions
): Promise<InvoiceNumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invoice-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.put<InvoiceNumberingSchemeResponse>(requestPath, data, requestOptions);
}
